import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import {SORTED_BY_COLUMN_DIRECTION_KEY, SORTED_BY_COLUMN_ID_KEY} from '../../platform/url'
import type {GetSubIssuesRequest, GetSubIssuesResponse, SubIssuesData} from './paginated-views'

export async function apiGetSubIssues(
  request: GetSubIssuesRequest,
  signal?: AbortSignal,
): Promise<GetSubIssuesResponse> {
  const apiData = getApiMetadata('memex-items-sub-issues-api-data')
  const url = new URL(apiData.url, window.location.origin)

  url.searchParams.set('issueId', `${request.parentId}`)

  url.searchParams.set('nwoReference', request.nwoReference)

  if (request.sortedBy) {
    for (const {columnId, direction} of request.sortedBy) {
      url.searchParams.append(SORTED_BY_COLUMN_DIRECTION_KEY, direction)
      url.searchParams.append(SORTED_BY_COLUMN_ID_KEY, `${columnId}`)
    }
  }

  const {data} = await fetchJSON<SubIssuesData>(url, {signal})

  return data
}
